var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ticketSettings)?_c('div',{staticClass:"invoice-message"},[(_vm.ticketSettings.i18n)?_c('div',{staticClass:"thankyou-message"},[_vm._v(_vm._s(_vm.$description(_vm.ticketSettings)))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }